export default __webpack_public_path__ + "94e4faf6dd5f97d50a33cdcb756bf517.svg";